import Axios from "axios"

export default {

  /**
   * 风控统计
   */
  risk(
    start,
    end
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/risk_statistic`, {
      params: {
        start,
        end
      }
    });
  },

  /**
   * 近30天渠道风控趋势
   */
  monthRiskTrend() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/sign_month_statistic`);
  },

  /**
   * 客流统计
   */
  flow(
    date_start,
    date_end
  ) {
    return Promise.all(
      [
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/volume/view`, {
          params: {
            date_start,
            date_end
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/image/view`, {
          params: {
            date_start,
            date_end
          }
        }),
        Axios.get(`${process.env.VUE_APP_PREFIX}/static/customer/view`, {
          params: {
            date_start,
            date_end
          }
        })
      ]
    );
  },

  /**
   * 近30天渠道风控趋势
   */
  monthFlowTrend() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/static/dayGroup/customer/view`);
  },

}